// The last moment a participant can cancel their own participation in an activity
// (docs/features/activity-cancellation-deadline.md).
//
// cancellationend is stored like entryend: on a one-off activity a 'YYYY-MM-DDTHH:mm' string
// (UTC wall clock), on a recurring template the number of minutes before the activity start.
// Empty means "same as entryend", which was the only behaviour before the field existed.
// Cancelling never stays open after enrolment has closed.

const isEmpty = (value) => value === null || value === undefined || value === ''

export const hasOwnCancellationEnd = (activity) => !!activity && !isEmpty(activity.cancellationend)

export const effectiveCancellationEnd = (activity) => {
  if (!activity) return null
  return hasOwnCancellationEnd(activity) ? activity.cancellationend : activity.entryend
}

export const CANCELLATIONEND_AFTER_ENTRYEND = 'Peruutuksen takaraja ei voi olla ilmoittautumisen päättymisen jälkeen'

export const cancellationEndError = (activity, { recurrent = false } = {}) => {
  if (!hasOwnCancellationEnd(activity) || isEmpty(activity.entryend)) return null
  if (recurrent) {
    // minutes before the start: a later deadline is a smaller number
    return Number(activity.cancellationend) < Number(activity.entryend) ? CANCELLATIONEND_AFTER_ENTRYEND : null
  }
  // both are 'YYYY-MM-DDTHH:mm', which compares correctly as text
  return String(activity.cancellationend) > String(activity.entryend) ? CANCELLATIONEND_AFTER_ENTRYEND : null
}

export const splitMinutes = (total) => {
  const value = Math.max(0, Math.floor(Number(total) || 0))
  return { days: Math.floor(value / (24 * 60)), hours: Math.floor((value % (24 * 60)) / 60), minutes: value % 60 }
}

export const joinMinutes = ({ days = 0, hours = 0, minutes = 0 } = {}) =>
  (Number(days) || 0) * 24 * 60 + (Number(hours) || 0) * 60 + (Number(minutes) || 0)
